import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Icon, Tooltip } from '@kontentino/ui';
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import ComparisonBadge from './ComparisonBadge';
import MetricComparisonCaption from './MetricComparisonCaption';
import MetricNotAvailable from './MetricNotAvailable';
import { NOT_AVAILABLE } from 'app/modules/analytics/modules/performance/utils/getPerformanceMetricDisplay';
import type { ChangeDirection } from 'api/new-analytics/types';

interface MetricHeaderProps {
  title: string;
  value?: string;
  badge?: number;
  badgeDirection?: ChangeDirection;
  tooltip?: string;
  caption?: string;
  isLoading?: boolean;
}

const MetricHeader: FC<MetricHeaderProps> = ({
  title,
  value,
  badge,
  badgeDirection,
  tooltip,
  caption,
  isLoading = false,
}) => {
  return (
    <div className="tw-flex tw-flex-col tw-items-start">
      <div className="tw-flex tw-items-center tw-gap-1">
        <span className="tw-text-md tw-font-medium tw-text-grayscale-180">
          {title}
        </span>
        {tooltip && (
          <Tooltip content={tooltip}>
            <span className="tw-flex tw-cursor-default tw-items-center tw-text-grayscale-100">
              <Icon icon={faCircleInfo} className="tw-text-xs" />
            </span>
          </Tooltip>
        )}
      </div>
      {isLoading ? (
        <Skeleton width="4.25rem" height={24} borderRadius={6} />
      ) : (
        value !== undefined && (
          <div className="tw-flex tw-flex-col tw-gap-2 lg:tw-flex-row lg:tw-items-center">
            <span className="tw-text-lg tw-font-semibold tw-text-grayscale-180">
              {value === NOT_AVAILABLE ? <MetricNotAvailable /> : value}
            </span>
            {(badge !== undefined ||
              badgeDirection === 'up' ||
              badgeDirection === 'down') && (
              <ComparisonBadge percentage={badge} direction={badgeDirection} />
            )}
          </div>
        )
      )}
      {!isLoading && <MetricComparisonCaption caption={caption} />}
    </div>
  );
};

export default MetricHeader;
